'use client';

import { SectionContainer, SectionRoot } from '@exploration/shared-components';
import { desktop, shadow } from '@thrivent/midwest-shared';
import { MDSAnchorButton, MDSText } from '@thrivent/midwest-web';
import NextImage from 'next/image';
import styled from 'styled-components';

export const ImageCardCtaStyle = {
  Section: styled(SectionRoot)``,
  Container: styled(SectionContainer)``,
  Card: styled.div`
    background-color: ${({ theme }) => theme.midwestColors.white};
    width: 100%;
    border-radius: 0.5rem;
    display: flex;
    flex-direction: column;
    box-shadow: ${shadow.sm};
    ${desktop} {
      flex-direction: row;
    }
  `,
  ImageContainer: styled.div`
    flex: 1 1 50%;
    position: relative;
    overflow: hidden;
    border-radius: 0.5rem 0.5rem 0 0;
    aspect-ratio: 2 / 1;
    @supports not (aspect-ratio: 2 / 1) {
      height: 10.5rem;
    }

    ${desktop} {
      border-radius: 0.5rem 0 0 0.5rem;
    }
  `,
  Image: styled(NextImage)`
    object-fit: cover;
    height: 100%;
    width: 100%;
  `,
  ContentContainer: styled.div`
    flex: 1 1 50%;
    display: flex;
    flex-direction: column;
    padding: 1rem 1rem 2.5rem;
    gap: 0.75rem;
    ${desktop} {
      padding: 4rem 7.5rem 4rem 5rem;
      gap: 1.5rem;
    }
  `,
  Title: styled(MDSText.HeroMd)`
    margin: 0;
  `,
  Description: styled(MDSText.BodyRegDefault)``,
  Button: styled(MDSAnchorButton)`
    margin-top: 0.75rem;
    width: 100%;
    ${desktop} {
      margin-top: 0;
      width: fit-content;
    }
  `,
};
